import { Button, VStack, Text } from '@chakra-ui/react';
import React, { ReactElement } from 'react';
import { ModalMainSubExpiresVariantProps, SharedModalProps } from 'types/Modal';
import { CustomModal } from '../CustomModal';
import { CustomModalContent } from '../CustomModalContent';

type Props = SharedModalProps & ModalMainSubExpiresVariantProps;

export const MainSubExpiresModal = ({ handleClose, isShown, endDate }: Props): ReactElement => {
  const handleContinue = (): void => {
    handleClose();
  };
  return (
    <CustomModal isOpen={isShown} onClose={handleClose} placement="center" hideHeader size="md">
      <CustomModalContent p="30px">
        <VStack gap="30px">
          <VStack gap="15px" alignItems="flex-start">
            <Text textStyle="body.m.medium">Hinweis zu Deinem AI-Abonnement</Text>
            <Text textStyle="body.m.regular">
              Dein Novaheal-Abonnement läuft am {endDate} aus. Ab dann kannst Du die AI-Funktionen
              nicht mehr verwenden – auch wenn Dein AI-Abo noch weiterläuft.
              <br />
              <br />
              👉 Verlängere Dein Novaheal-Abonnement, um die AI-Funktionen bis zum Ende Deiner
              AI-Abo Laufzeit zu nutzen.
              <br />
              <br />
              👉 Falls Du keine Verlängerung möchtest, kündige bitte auch Dein AI-Abo rechtzeitig,
              damit keine zusätzlichen Kosten entstehen.
            </Text>
          </VStack>

          <Button onClick={handleContinue} variant="primary" w="full">
            Weiter
          </Button>
        </VStack>
      </CustomModalContent>
    </CustomModal>
  );
};
